jQuery(document).ready(function () {
    jQuery.cookieBar({
        message: 'Per offrirti una migliore esperienza questo sito utilizza cookie di profilazione, anche di terze parti. ' +
            'Chiudendo questo banner o cliccando qualsiasi elemento acconsenti all\'utilizzo dei cookie. ' +
            'Per saperne di più consulta la nostra Privacy Policy</a>',
        acceptButton: true,
        acceptText: 'Ok',
        acceptFunction: null,
        declineButton: false,
        declineText: 'Disable Cookies',
        declineFunction: null,
        policyButton: true,
        policyText: 'Privacy Policy',
        policyURL: '/privacy-policy/',
        autoEnable: true,
        acceptOnContinue: false,
        acceptOnScroll: false,
        acceptAnyClick: true,
        expireDays: 365,
        renewOnVisit: false,
        forceShow: false,
        element: 'body',
        append: false,
        fixed: true,
        bottom: true,
        zindex: '9999',
        effect: 'fade',
        domain: 'nepgroup.it',
        referrer: 'nepgroup.it'
    });
});

/**
 * Axios tokens header
 */
var token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

var userApiToken = document.head.querySelector('meta[name="user-api-token"]');

if (userApiToken) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + userApiToken.content;
} else {
    console.error('User API token not found in a meta tag.');
}

/**
 * Main menu mobile
 */
function toggleMenu() {
    $('#main-menu').fadeToggle("slow", "linear");


    var y = document.getElementById("hamburger-toggle");
    if (y.className === "hamburger-toggle") {
        y.className += " close";
    } else {
        y.className = "hamburger-toggle";
    }
}

function toggle(id) {
    $('#' + id).slideToggle("slow");
}

$(document).ready(function () {

    //fix loadig js lag
    $('.no-js').removeClass("no-js");

    //big carousel
    $('.main-slide').slick({
        autoplay: true,
        dots: true,
    });


    //responsive carousel
    $('.responsive-slide').slick({
        autoplay: true,
        dots: true,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,

        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    adaptiveHeight: true
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]

    });

});

if ($('body').hasClass('supporto')) {
    var currentTab = 0;
    showTab(currentTab);
}

function apri(id) {
    $('#' + id).slideToggle("slow");
}

function addPartecipant(element) {
    var thisId = $(element).parent().data('id');
    var cloneClass = document.getElementsByClassName('to-clone');

    for (e = 0; e < cloneClass.length; e++) {
        var currentID = cloneClass[e].getAttribute('data-id');

        if (currentID === thisId) {
            alert('ok');
        }
    }
}

/*
Pagina supporto
---------------------*/

/**
 * Page tabs manager
 */
function showTab(n) {
    // This function will display the specified tab of the form ...
    var x = document.getElementsByClassName("page-section-tab");

    if (n > 0) {
        var toHide = x[n - 1].getAttribute('id');
        var toShow = x[n].getAttribute('id');

        $('.page-section-tab').slideUp('slow');
        $("#" + toShow).slideDown('slow');
        $('#back-arrow').css('display', 'inline-block');
    } else {
        $('.page-section-tab').slideUp('slow');
        var toShow = x[n].getAttribute('id');
        $("#" + toShow).slideDown('slow');
        //x[n].style.display = "block";
        $('#back-arrow').css('display', 'none');
    }

}

/*
Air Datepicker
---------------------*/

// Italiano
$.fn.datepicker.language['it'] = {
    days: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
    daysShort: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
    daysMin: ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa'],
    months: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
    monthsShort: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
    today: 'Oggi',
    clear: 'Clear',
    dateFormat: 'mm/gg/aaaa',
    timeFormat: 'hh:ii aa',
    firstDay: 1
};

// Array to container Air Datepicker days to enable. Date format: yyyy-mm-dd
var enabledDays = [];

$('#availability-cal').datepicker({
    language: 'it',
    onRenderCell: function (date, cellType) {
        if (cellType == 'day') {
            var jsDate = moment(date);
            var day = jsDate.format('YYYY-MM-DD'),
                isDisabled = enabledDays.indexOf(day) == -1;
            return {
                disabled: isDisabled
            }
        }
    },
    onSelect: function (formattedDate, date, inst) {
        if (formattedDate) {
            currentTab++;

            var jsDate = moment(date);

            var myFormattedDate = jsDate.format('YYYY-MM-DD');

            $('#date-selected').html(jsDate.format('DD/MM/YYYY'));
            $('#booking-date').val(myFormattedDate);
            $('.date-hours').hide();
            $('.date-hours[data-date="' + myFormattedDate + '"]').show();

            showTab(currentTab);
        }
    }
});

$('#back-arrow').click(function (e) {
    e.preventDefault();

    $('#availability-cal').data('datepicker').clear();
    currentTab--;
    showTab(currentTab);
});

function getAvailability(tutorId, tutorName) {
    let params = {};
    if (tutorId) {
        params.tutor_id = tutorId;
    }

    axios.get('/api/helpdesk/get-availability', {
        params
    }).then(function (response) {
        var data = response.data;

        $('#tutor-selected').html(tutorName);
        $('#booking-tutor-id').val(tutorId);
        $('#hours-container').empty();

        enabledDays = [];

        for (var date in data) {
            var jsDate = moment(date, "YYYY-MM-DD");
            enabledDays.push(jsDate.format('YYYY-MM-DD'));
            var hours = data[date];
            var hoursHtml = '<div class="row date-hours" data-date="' + jsDate.format('YYYY-MM-DD') + '">';
            hours.forEach(function (element) {
                hoursHtml = hoursHtml + '<div class="col-6 col-sm-6 col-md-4 col-lg-3">' +
                    '<div data-duration="' + element.duration + '" ' +
                    'data-rate="' + element.rate + '" ' +
                    'data-currency-symbol="' + element.currency.symbol + '" ' +
                    'data-currency-code="' + element.currency.code + '" ' +
                    'data-tutor-id="' + element.tutor_id + '" ' +
                    'data-from="' + element.from + '" ' +
                    'data-to="' + element.to + '" ' +
                    'class="availability-time min-' + element.duration + '">' +
                    element.from + ' - ' + element.to +
                    '</div> ' +
                    '</div>';
            });
            hoursHtml = hoursHtml + "</div>";
            $('#hours-container').append(hoursHtml);
        }

        $('.date-hours').hide();

        $('#availability-cal').data('datepicker').clear();

        currentTab++;
        showTab(currentTab);
    }).catch(function (error) {
            console.log(error);
        }
    );
}

$('#tutors-container').on('click', '.tutor', function(e) {
    e.preventDefault();

    $('.tutor').removeClass('selected');

    $('#availability-cal').data('datepicker').clear();

    var $elem = $(this);
    $elem.addClass('selected');
    var tutorId = $elem.data('id');
    var tutorName = $elem.data('name');

    getAvailability(tutorId, tutorName);
});

$('.coursetype-button').click(function (e) {
    e.preventDefault();
    const value = $(this).data('value');
    const name = $(this).data('name');
    
    $('#course_type-selected').html(name);
    $('#booking-coursetype-id').val(value);
    
    let params = {
        course_type_id: value
    };

    $('.coursetype-button').attr('disabled', 'disabled');
    axios.get('/api/helpdesk/get-tutors', {
        params
    }).then(function (response) {
        var data = response.data;
        $('#tutors-container .tutor-container').remove();

        var html = '';
        data.forEach(function (tutor) {
            html += '<div class="col-6 col-md-4 tutor-container">';
            html += '<div data-name="'+tutor.fullname+'" data-id="'+tutor.id+'" class="tutor">';
            html += '<img alt="'+tutor.fullname+'" src="'+tutor.profile_image+'">';
            html += '<p>'+tutor.fullname+'</p>';
            html += '</div>';
            html += '</div>';
        });

        $('#tutors-container').append(html);

        currentTab++;
        showTab(currentTab);
    }).then(function () {
        $('.coursetype-button').removeAttr('disabled');
    });
});


/*
 * Hour Picker
 *-------------*/

$('#hours-container').on('click', '.availability-time', function (e) {
    e.preventDefault();

    let from = $(this).data('from');
    let to = $(this).data('to');
    let tutorId = $(this).data('tutor-id');
    let rate = $(this).data('rate');
    let currencySymbol = $(this).data('currency-symbol');
    let currencyCode = $(this).data('currency-code');
    let duration = $(this).data('duration');

    $('.availability-time').removeClass('active');
    $(this).addClass('active');

    $('#booking-from').val(from);
    $('#booking-to').val(to);
    $('#booking-coursetype-id').val();
    $('#booking-tutor-id').val(tutorId);
    $('#time-selected').html(from);
    $('#duration-selected').html(duration);
    $('#rate-selected').html(rate + currencySymbol);
    $('#booking-amount').html(rate);
    $('#booking-amount').val(rate);
    $('#booking-currency').html(currencySymbol);
    $('#booking-currency').val(currencyCode);

    currentTab++;
    showTab(currentTab);
});

$('#booking-form').one('submit', function (e) {
    e.preventDefault();
    $('#confirm-booking').attr('disabled', 'disabled');
    $(this).submit();
});

/*
$('#confirm-booking').click(function () {

    axios.post('/api/helpdesk/book', {
        date: $('#booking-date').val(),
        from: $('#booking-from').val(),
        to: $('#booking-to').val(),
        tutor_id: $('#booking-tutor-id').val(),
        user_id: $('#booking-user-id').val(),
        amount: $('#booking-amount').val(),
        currency: $('#booking-currency').val()
    }).then(function (response) {
        currentTab++;
        showTab(currentTab);
        $('#back-arrow').css('display', 'none');
    }).catch(function (error) {
        console.log(error);
    });

});
*/

function toggleRegisterStep(step) {
    $('.register-form-step').each(function() {
        if ($(this).data('step') === step) {
            $(this).addClass('active');
            $(this).removeClass('hide');
        } else {
            $(this).removeClass('active');
            $(this).addClass('hide');
        }
    });
}

function getCurrentRegisterStep() {
    return $('.register-form-step.active').data('step');
}

$(function () {
    toggleRegisterStep(1);

    $('.register-form-next-step-button').on('click', function(e) {
        e.preventDefault();
        toggleRegisterStep(getCurrentRegisterStep() + 1);
    });

    $('.register-form-prev-step-button').on('click', function(e) {
        e.preventDefault();
        toggleRegisterStep(getCurrentRegisterStep() - 1);
    });

    $('#submit-register').on('click', function(e) {
        e.preventDefault();
        let isValid = true;
        let inputs = document.getElementsByClassName('register-form-input');
        for (let i = 0; i < inputs.length; i++) {
            if (!inputs[i].checkValidity()) {
                isValid = false;
            }
        }
        if (!isValid) {
            $('#register-form .error-messages').removeClass('hide');
        } else {
            $('#register-form').submit();
        }
    });
});